import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  queryContentList: '/cms/cmsContent/queryContentList',
  queryContentListByUser: '/cms/cmsContent/queryContentListByUser',
};

/**
 * 获取首页banner
 * @param query
 * @returns {{result: unknown, loading: boolean, error: Error, getBanner: (...params: any[]) => Promise<unknown>}}
 */
export const useQueryContentList = (query) => {
  
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.queryContentList,
      method: 'get',
      data: query || q || {}
    }, { noAgent: true });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    error,
    getBanner: runAsync,
  };
};

/**
 * 获取首页推荐商品
 * @param query
 * @returns {{result: unknown, loading: boolean, error: Error}}
 */
export const useQueryContentListByUser = (query) => {
  const { data, runAsync, error, loading } = useRequest(() => {
    return http({
      url: apiPath.queryContentListByUser,
      method: 'get',
      data: query
    });
  });
  
  return {
    result: data || {},
    loading,
    error,
    getRecommend: runAsync
  };
};
